import ProfessorRepository from '../../domain/repositories/ProfessorRepository';
import ProfessorDataStoreFactory from '../factories/ProfessorDataStoreFactory';
import ProfessorDataStore from '../datastores/ProfessorDataStore';

export default class ProfessorDataRepository implements ProfessorRepository {
  getProfessors() {
    const professorDataStore: ProfessorDataStore =
      ProfessorDataStoreFactory.create();
    return professorDataStore.getProfessors();
  }
}
